<template>
  <div class="download" @scroll="scroll($event)">
    <!-- <topMenu pageType='recommend' /> -->
    <isWeixinMark :isWeixin="isWeixin" @onCancelMark="isWeixin=false" />
    <catalogue :list="list" />
    <div class="downloadImage" @click="onDownload">
      <img src="../assets/images/xiazai_duan.png" />
    </div>
    <div class="box">
    <div class="detail"  @scroll.passive="scroll($event)">
      <div class="detailItem" v-for="(item, index) in list" :key="index" @click="videoDetail(item)">
        <img :src="item.page_img" />
        <!-- <video :class="item.video_type === 2 ? 'videoJust' : 'videoWide'" :src="item.sources" controls="controls" controlslist="nodownload" playsinline :poster="item.video_page" /> -->
        <a :id="'title'+ index" />
        <p>{{index + 1}}.{{item.title}}</p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
// import topMenu from '../components/topMenu'
import catalogue from '../components/catalogue'
import isWeixinMark from '../components/isWeixinMark'
import { getList, getFirmList } from '../api/wap'
export default {
  name: 'New',
  components: {
    // topMenu,
    isWeixinMark,
    catalogue
  },
  data () {
    return {
      downloadLink: '',
      isWeixin: false,
      get_key: '',
      page_now: 1,
      page_total: '',
      list: [ ],
      title: ''
    }
  },
  created () {
    if (this.$route.query.get_key) this.get_key = this.$route.query.get_key
    // console.log(this.get_key)
    this.onLoadData()
    this.getFirmList()
  },
  // mounted () {
  //   console.log(this.title)
  //   document.title = `联吧/${this.title}`
  // },
  methods: {
    onLoadData () {
      getList({ type: 1 }).then((res) => {
        this.downloadLink = res.result.download_url.android
      })
    },
    onDownload () {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        location.href =
          'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
      }
      if (isAndroid) {
        this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
        if (!this.isWeixin) {
          location.href = this.downloadLink
        }
      }
    },
    videoDetail (e) {
    //   console.log( e )
      if (e.type === 1) {
        this.$router.push({
          path: '/videoDetail',
          query: {
            sources: e.sources,
            title: e.title,
            video_page: e.page_img
          }
        })
      } else {
        localStorage.setItem('content', e.content)
        this.$router.push({
          path: '/directionsDetail',
          query: {
            // content: e.content,
            title: e.title
          }
        })
      }
    },
    getFirmList () {
      getFirmList({
        get_key: this.get_key
      }).then(res => {
        // console.log(res.status)
        if (res.status === 200) {
          this.list.push(...res.result.detail)
          this.page_total = res.page_total
          this.title = res.result.firm_name
          document.title = `联吧/${this.title}`
        } else {
          this.$router.push({ path: '/download', query: {} })
        }
        // console.log(res.result)
      }).catch(e => {
        this.$router.push({ path: '/download', query: {} })
      })
    },
    scroll (e) {
      let s = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight
      // console.log(s)
      if (s === 0) {
        if (this.page_now < this.page_total) {
          this.page_now++
          this.getFirmList()
        }
      }
    }
  }
}
</script>

<style scoped>
.downloadImage {
  margin-top: .5rem;
  text-align: center;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.download {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.box {
  flex: 1;
  overflow-y: auto;
}
.detail {
  padding: 0.4rem 0 1rem;
  margin: 0 0.1rem;
  display: flex;
  flex-wrap: wrap;
}
.detailItem {
  /* margin-top: 0.59rem; */
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
  margin-bottom: .59rem;
}
.detailItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0.2rem 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.detailItem img {
  /* margin-top: 0.3rem; */
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.videoJust {
  width: 7.1rem;
  height: 7.1rem;
}
.videoWide {
  width: 7.1rem;
  height: 4rem;
}
</style>
